
export const EDITOR_SLOT_PROVIDER = 'EDITOR_SLOT_PROVIDER';


export const EDITOR_DEFAULT_HEIGHT = 80;


export const EditorLayoutDefaultID = '+1';




// editors id
export const RESOURCE_EDITOR_ID = 'workbench.editors.resourceEditor';
/**
 * Text diff editor id.
 */
export const TEXT_DIFF_EDITOR_ID = 'workbench.editors.textDiffEditor';

/**
 * Binary diff editor id.
 */
export const BINARY_DIFF_EDITOR_ID =
  'workbench.editors.binaryResourceDiffEditor';

export const SIDE_BY_SIDE_EDITOR_ID = 'workbench.editor.sidebysideEditor';

export const PREFERENCE_EDITOR_ID = 'workbench.editor.preferenceeditor';

// remove it and use from `core`
export const ClientExtensions = {
  Editors: 'workbench.contributions.editors',
  EditorInputFactories: 'workbench.contributions.editor.inputFactories',
};
